import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import '../../App.css';

const notify = (message, type = 'default') => {
  // Style for Success


  switch (type) {
    case 'success':
      toast.success(message);
      break;
    case 'error':
      toast.error(message);
      break;
    case 'info':
      toast.info(message);
      break;
    case 'warning':
      toast.warn(message);
      break;
    default:
      toast(message);
  }
};

export default notify;
